import { useRecordContext, useNotify } from "react-admin";
import { Button, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import MapIcon from "@mui/icons-material/Map";
import { gmapsQueryUrl, joinAddressLine } from "../components/raFormat";

export function AddressQuickActions() {
  const r = useRecordContext<any>();
  const notify = useNotify();
  if (!r) return null;

  const line = joinAddressLine(r);

  return (
    <Stack direction="row" spacing={1}>
      <Button
        size="small"
        variant="outlined"
        startIcon={<ContentCopyIcon />}
        onClick={async () => {
          await navigator.clipboard.writeText(line);
          notify("Adresse kopiert", { type: "info" });
        }}
      >
        Kopieren
      </Button>

      <Button
        size="small"
        variant="outlined"
        startIcon={<MapIcon />}
        component="a"
        href={gmapsQueryUrl(r)}
        target="_blank"
        rel="noreferrer"
      >
        Karte
      </Button>
    </Stack>
  );
}
